import React from "react";
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useTheme } from "../../../context/ThemeContext";

const AnnouncementCard = ({ item }) => {
	const theme = useTheme();
	const styles = useStyles();

	return (
		<TouchableOpacity style={[styles.card, item.priority === "high" && styles.highPriority]}>
			<View style={styles.cardHeader}>
				<View style={styles.priorityIndicator} />
				<Text style={styles.cardTitle}>{item.title}</Text>
			</View>
			<Text style={styles.cardDescription} numberOfLines={2}>
				{item.description}
			</Text>
			<View style={styles.cardFooter}>
				<Text style={styles.timeText}>{item.time}</Text>
				{item.hasAction && (
					<TouchableOpacity style={styles.actionButton}>
						<Text style={styles.actionButtonText}>Take Action</Text>
						<Ionicons name="arrow-forward" size={16} color={theme.colors.primary} />
					</TouchableOpacity>
				)}
			</View>
		</TouchableOpacity>
	);
};

export const Announcements = ({ content, label = "Announcements" }) => {
	const theme = useTheme();
	const styles = useStyles();

	return (
		<View style={styles.container}>
			<View style={styles.header}>
				<Text style={styles.label}>{label}</Text>
			</View>
			<ScrollView style={styles.announcements} horizontal showsHorizontalScrollIndicator={false}>
				{content.items.map((announcement) => (
					<AnnouncementCard key={announcement.id} item={announcement} />
				))}
			</ScrollView>
		</View>
	);
};

const useStyles = () => {
	const theme = useTheme();

	return StyleSheet.create({
		container: {
			backgroundColor: theme.colors.systemBackground.primary,
			marginBottom: theme.spacing.sm,
			borderRadius: theme.borderRadius.lg,
			...theme.shadows.sm,
		},
		header: {
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center",
			paddingHorizontal: theme.spacing.md,
			paddingTop: theme.spacing.sm,
			paddingBottom: theme.spacing.xs,
		},
		label: {
			...theme.typography.subhead,
			color: theme.colors.textSecondary,
			fontWeight: "500",
		},
		moreButton: {
			flexDirection: "row",
			alignItems: "center",
			gap: theme.spacing.xs,
		},
		moreButtonText: {
			...theme.typography.subhead,
			color: theme.colors.primary,
		},
		announcements: {
			paddingHorizontal: theme.spacing.md,
			paddingBottom: theme.spacing.md,
		},
		card: {
			width: 280,
			backgroundColor: theme.colors.systemBackground.secondary,
			borderRadius: theme.borderRadius.lg,
			padding: theme.spacing.md,
			marginRight: theme.spacing.md,
			...theme.shadows.sm,
		},
		highPriorityCard: {
			borderWidth: 1,
			borderColor: theme.colors.systemRed,
		},
		cardHeader: {
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "flex-start",
			marginBottom: theme.spacing.sm,
		},
		cardTitle: {
			...theme.typography.headline,
			color: theme.colors.text,
			flex: 1,
			marginRight: theme.spacing.sm,
		},
		priorityBadge: {
			backgroundColor: theme.colors.systemRed,
			paddingHorizontal: theme.spacing.sm,
			paddingVertical: theme.spacing.xs,
			borderRadius: theme.borderRadius.pill,
		},
		priorityText: {
			...theme.typography.caption2,
			color: theme.colors.systemBackground.primary,
			fontWeight: "600",
		},
		cardDescription: {
			...theme.typography.subhead,
			color: theme.colors.textSecondary,
			marginBottom: theme.spacing.md,
		},
		cardFooter: {
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center",
		},
		timeText: {
			...theme.typography.caption2,
			color: theme.colors.textTertiary,
		},
		actionButton: {
			flexDirection: "row",
			alignItems: "center",
			gap: theme.spacing.xs,
		},
		actionButtonText: {
			...theme.typography.subhead,
			color: theme.colors.primary,
		},
		highPriority: {
			borderWidth: 1,
			borderColor: theme.colors.systemRed,
		},
		priorityIndicator: {
			width: 8,
			height: 8,
			borderRadius: 4,
			backgroundColor: theme.colors.systemRed,
			marginRight: theme.spacing.sm,
		},
	});
};
